import axios from "axios";

const instance = axios.create({
  baseURL: "https://ingenioback.idslatam.com/Identity",
//baseURL: "https://ingeniobackqas.idslatam.com/Identity",
//baseURL: "https://localhost:21499/",
  //baseURL: "https://ingenioqas-poderosa.idslatam.com/Identity",
});

var token = window.localStorage.getItem("jwt");

instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;

export default instance;
